import React from 'react';

interface Props {
  children: React.ReactNode;
}

export const Body = ({ children }: Props) => {
  return <div>{children}</div>;
};
